import axios from '_u/axios'

// 园区房间状态数量统计
export const houseStatistic = (id) => {
    return axios.post('api/ems/stats/houseStatistic', { parkId: id })
}

// 收入统计
export const inComeStatistic = (id) => {
    return axios.post('api/ems/stats/inComeStatistic', { dimension: id })
}

// 支出统计
export const disburseStatistic = (id) => {
    return axios.post('api/ems/stats/disburseStatistic', { dimension: id })
}

// 近7天的收入统计
export const nearInComeStatistic = () => {
    return axios.post('api/ems/stats/nearInComeStatistic')
}

// 年度收支趋势
export const yearFeeTrend = (year) => {
    return axios.post('api/ems/stats/yearFeeTrend', { year })
}

// 入住率统计
export const liveRateStatistic = (dimension) => {
    return axios.post('api/ems/stats/liveRateStatistic', { dimension })
}

// 交租拖欠率
export const payRentStatistic = (dimension) => {
    return axios.post('api/ems/stats/payRentStatistic', { dimension })
}

// 收入占比
export const incomeRateStatistic = (dimension) => {
    return axios.post('api/ems/stats/incomeRateStatistic', { dimension })
}

// 年度客户转化率
export const cusStatistic = (dimension) => {
    return axios.post('api/ems/stats/cusStatistic', { dimension })
}

// 首页-异常提醒
export const iotException = () => {
    return axios.post('/api/ems/stats/iotException')
}

// 首页-合约到期统计
export const houseContractStatistic = () => {
    return axios.post('api/ems/stats/houseContractStatistic')
}

// 首页-出房退房统计
export const inAndOutStatistic = () => {
    return axios.post('api/ems/stats/inAndOutStatistic')
}

// 首页-账单账务统计
export const billAccountStatistic = () => {
    return axios.post('api/ems/stats/billAccountStatistic')
}

// 首页-维修投诉数据统计
export const repairComplaintStatistic = () => {
    return axios.post('api/ems/stats/repairComplaintStatistic')
}

// 首页-账单和合同的数据统计
export const billContractStatistic = () => {
    return axios.post('api/ems/stats/billContractStatistic')
}
